import {Injectable} from "@angular/core";
import {AreaGroupModel} from "./area-group.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {toBoolean, toList} from "../helpers/helpers";
import {AreaModel} from "./area.model";

export type GroupResponseType = {
  groups: AreaGroupModel[];
  itsmGroups: any[];
  itsmAreas: any[];
  projectHasCustomer: boolean;
  targetSystem: string;
};

@Injectable()
export class AreaGroupService {
  private url: string = "/api/grouping";

  constructor(private http: HttpClient) {}

  getGroupsByProjectId(projectId): Promise<GroupResponseType> {
    return this.http.get(`${this.url}?projectId=${projectId}`)
      .pipe(
        map(json => ({
          groups: toList(AreaGroupModel.converter, json["groups"]),
          itsmGroups: toList(AreaGroupModel.converter, json["itsmGroups"]),
          itsmAreas: toList(AreaModel.converter, json["itsmAreas"]),
          projectHasCustomer: toBoolean(json["projectHasCustomer"]),
          targetSystem: json["targetSystem"] || "legacy",
        })),
      )
      .toPromise();
  }

  async updateProjectGroups(projectId: string, groupsToUpdate: any[]): Promise<boolean> {
    if (!projectId || !groupsToUpdate) {
      throw new Error("Project & Groups should be provided");
    }

    return this.http.post(`${this.url}/save-project-groups`, {projectId, groupsToUpdate})
      .pipe(
        map(json => json["success"]),
      )
      .toPromise();
  }

  async sendAreaGroupsToITSM(projectId: string, groupsToSend: any[]): Promise<any> {
    if (!projectId) {
      throw new Error("Project should be provided");
    }

    return this.http.post(`${this.url}/send-area-groups-to-itsm`, {projectId, groupsToSend})
      .pipe(
        map(response => response),
      )
      .toPromise();
  }
}
